import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { db, storage } from "./Firebase";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  addDoc,
} from "firebase/firestore";
import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import styled from "styled-components";
import { MoonLoader } from "react-spinners";
import { FormGroup } from "./CostCalculadora";

const Container = styled.div`
  padding: 30px;
  max-width: 700px;
  margin: 0 auto;
  font-family: "Roboto", sans-serif;
`;

const Section = styled.div`
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
`;

const Button = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #c20000;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FileInput = styled.input`
  margin-top: 20px;
`;

const SuccessMessage = styled.p`
  color: green;
  margin-top: 20px;
  font-weight: bold;
`;

const ConfirmacionContrato = () => {
  const [searchParams] = useSearchParams();
  const contratoNumero = searchParams.get("contrato");
  const [contrato, setContrato] = useState(null);
  const [confirmado, setConfirmado] = useState(false);
  const [archivo, setArchivo] = useState(null);
  const [subiendoArchivo, setSubiendoArchivo] = useState(false);
  const [confirmandoContrato, setConfirmandoContrato] = useState(false);
  const [contratoURL, setContratoURL] = useState(null);
  const [datosCliente, setDatosCliente] = useState({
    nombre: "",
    apellido: "",
    dni: "",
    fechaNacimiento: "",
  });
  const [errores, setErrores] = useState([]);
  const [aceptoTerminos, setAceptoTerminos] = useState(false);

  useEffect(() => {
    if (!contratoNumero) return;
    const fetchContrato = async () => {
      const q = query(
        collection(db, "contratos"),
        where("contratoNumero", "==", contratoNumero)
      );
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const contratoData = querySnapshot.docs[0].data();
        const id = querySnapshot.docs[0].id;
        setContrato({ ...contratoData, id });

        // Buscar el PDF generado en Storage
        const contratoRef = ref(
          storage,
          `contratos/Contrato-${contratoNumero}.pdf`
        );
        try {
          const url = await getDownloadURL(contratoRef);
          setContratoURL(url);
        } catch (error) {
          console.error("No se encontró el contrato en Storage:", error);
        }
      }
    };
    fetchContrato();
  }, [contratoNumero]);

  const handleConfirmar = async () => {
    const { nombre, apellido, dni, fechaNacimiento } = datosCliente;
    const erroresValidados = [];
    if (!contrato) return;
    if (!aceptoTerminos) {
      setErrores(["Debe aceptar los términos y condiciones para continuar."]);
      return;
    }
    if (!nombre.trim()) erroresValidados.push("El nombre es obligatorio.");
    if (!apellido.trim()) erroresValidados.push("El apellido es obligatorio.");
    if (!dni.trim() || dni.length < 7) erroresValidados.push("DNI inválido.");
    if (!fechaNacimiento.trim())
      erroresValidados.push("Fecha de nacimiento obligatoria.");
    if (erroresValidados.length > 0) {
      setErrores(erroresValidados);
      return;
    }

    setErrores([]);

    setConfirmandoContrato(true);

    const contratoRef = doc(db, "contratos", contrato.id);
    const fecha = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const ip = await getClientIp();

    await updateDoc(contratoRef, {
      confirmadoPorCliente: true,
      fechaConfirmacion: fecha,
      ipConfirmacion: ip,
      navegador: userAgent,
      confirmacionCliente: {
        nombre,
        apellido,
        dni,
        fechaNacimiento,
      },
    });

    await addDoc(collection(db, "mail"), {
      to: [
        "rojas_dario@catainternacional.com",
        "sanchez_marisa@catainternacional.com",
        "carmona_juliana@catainternacional.com",
        "mendoza_dairelys@catainternacional.com",
        "trafico@catainternacional.com",
      ],
      from: `"Servicios Especiales" <rojas_dario@catainternacional.com>`,
      message: {
        subject: `Confirmación digital de Contrato - ${
          contrato?.nombreApellido || "Cliente"
        }`,
        html: `
          <p style="margin: 0px"><strong>El presente contrato ha sido aceptado digitalmente por el cliente, quien manifiesta su consentimiento libre, informado y expreso, conforme a lo dispuesto por la Ley N° 25.506 de Firma Digital, dejando constancia registral de dicha aceptación.</strong></p>
          <br>
          <p style="margin: 0px"><strong>Contrato N°:</strong> ${
            contrato?.contratoNumero
          }</p>
          <p style="margin: 0px"><strong>Nombre:</strong> ${nombre} ${apellido}</p>
          <p style="margin: 0px"><strong>DNI:</strong> ${dni}</p>
          <p style="margin: 0px"><strong>Fecha de Nacimiento:</strong> ${fechaNacimiento}</p>
          <p style="margin: 0px"><strong>Navegador:</strong> ${userAgent}</p>
          <p style="margin: 0px"><strong>IP:</strong> ${ip}</p>
          <p style="margin: 0px"><strong>Fecha de registro:</strong> ${new Date(
            fecha
          ).toLocaleString("es-AR")}</p>
          <br>
          ${
            contratoURL
              ? `<p style="margin: 0px"><a href="${contratoURL}" target="_blank">Descargar Contrato PDF</a></p>`
              : `<p style="color:red; margin: 0px;">No se encontró el contrato PDF.</p>`
          }
          <br>
            <p style="margin: 0px;">Atentamente,</p>
            <p style="margin: 0px;">Equipo Serv. Especiales</p>
          <br>
          <hr>
          <p style="margin: 0px; font-size: 12px; color: #555;">
            Este es un correo automático generado por el sistema de contratos de Servicios Especiales.
          </p>
        `,
      },
    });

    setConfirmado(true);
    setConfirmandoContrato(false);
  };

  const getClientIp = async () => {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data.ip;
    } catch {
      return "IP no disponible";
    }
  };

  const handleUpload = async () => {
    if (!archivo || !contrato) return;
    setSubiendoArchivo(true);

    const storageRef = ref(
      storage,
      `contratos_firmados/Contrato-Firmado-${contrato.contratoNumero}.pdf`
    );
    await uploadBytes(storageRef, archivo);

    const downloadURL = await getDownloadURL(storageRef);
    const contratoRef = doc(db, "contratos", contrato.id);

    await updateDoc(contratoRef, {
      contratoFirmadoURL: downloadURL,
      firmadoManual: true,
    });

    await addDoc(collection(db, "mail"), {
      to: [
        "rojas_dario@catainternacional.com",
        "sanchez_marisa@catainternacional.com",
        "carmona_juliana@catainternacional.com",
        "mendoza_dairelys@catainternacional.com",
        "trafico@catainternacional.com",
      ],
      from: `"Servicios Especiales" <rojas_dario@catainternacional.com>`,
      message: {
        subject: `Contrato Firmado Manualmente - ${
          contrato?.nombreApellido || "Cliente"
        }`,
        html: `
          <p style="margin: 0px"><strong>Contrato firmado manualmente subido.</strong></p>
          <br>
          <p style="margin: 0px"><strong>Contrato N°:</strong> ${contrato?.contratoNumero}</p>
          <p style="margin: 0px"><a href="${downloadURL}" target="_blank">Descargar Contrato Firmado</a></p>
          <br>
            <p style="margin: 0px;">Atentamente,</p>
            <p style="margin: 0px;">Equipo Serv. Especiales</p>
          <br>
          <hr>
          <p style="margin: 0px; font-size: 12px; color: #555;">
            Este es un correo automático generado por el sistema de contratos de Servicios Especiales.
          </p>
        `,
      },
    });

    alert("Contrato firmado subido correctamente. ¡Gracias!");
    setSubiendoArchivo(false);
  };

  return (
    <Container>
      {contrato ? (
        <>
          <h2>Confirmación de Contrato</h2>
          <p>
            Contrato emitido para <strong>{contrato.nombreApellido}</strong>.
          </p>

          {contratoURL ? (
            <a href={contratoURL} target="_blank" rel="noreferrer">
              Descargar Contrato PDF
            </a>
          ) : (
            <p style={{ color: "red" }}>
              No se encontró el contrato en Storage.
            </p>
          )}

          {!confirmado ? (
            <>
              <Section>
                <h4>Envíe el contrato firmado</h4>
                <FileInput
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => setArchivo(e.target.files[0])}
                />
                <Button
                  onClick={handleUpload}
                  disabled={subiendoArchivo || !archivo}
                >
                  {subiendoArchivo ? (
                    <MoonLoader size={20} color="#fff" />
                  ) : (
                    "Subir Contrato Firmado"
                  )}
                </Button>
              </Section>
              <Section>
                <h4>Información Legal</h4>
                <p>
                  Conforme a la <strong>Ley 25.506 de Firma Digital</strong>, su
                  confirmación digital posee plena validez legal. También puede
                  imprimir, firmar y subir el contrato firmado manualmente.
                </p>
              </Section>
              <Section>
                <h4>Complete sus datos para validar la firma digital</h4>
                <FormGroup>
                  <label>Nombre:</label>
                  <input
                    type="text"
                    value={datosCliente.nombre}
                    onChange={(e) =>
                      setDatosCliente({
                        ...datosCliente,
                        nombre: e.target.value,
                      })
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <label>Apellido:</label>
                  <input
                    type="text"
                    value={datosCliente.apellido}
                    onChange={(e) =>
                      setDatosCliente({
                        ...datosCliente,
                        apellido: e.target.value,
                      })
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <label>DNI:</label>
                  <input
                    type="text"
                    value={datosCliente.dni}
                    onChange={(e) =>
                      setDatosCliente({ ...datosCliente, dni: e.target.value })
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <label>Fecha de Nacimiento:</label>
                  <input
                    type="date"
                    value={datosCliente.fechaNacimiento}
                    onChange={(e) =>
                      setDatosCliente({
                        ...datosCliente,
                        fechaNacimiento: e.target.value,
                      })
                    }
                  />
                </FormGroup>
                  <label>
                    <input
                      type="checkbox"
                      checked={aceptoTerminos}
                      onChange={(e) => setAceptoTerminos(e.target.checked)}
                      style={{ marginRight: 8 }}
                    />
                    Declaro haber leído el contrato, aceptar los términos y
                    condiciones, y firmar digitalmente conforme a la Ley 25.506.
                  </label>
                {errores.length > 0 && (
                  <ul style={{ color: "red", padding: 0, listStyle: "none" }}>
                    {errores.map((error, i) => (
                      <li key={i}>{error}</li>
                    ))}
                  </ul>
                )}
              </Section>
              <Button onClick={handleConfirmar} disabled={confirmandoContrato}>
                {confirmandoContrato ? (
                  <MoonLoader size={20} color="#fff" />
                ) : (
                  "Confirmar Contrato Digitalmente"
                )}
              </Button>
            </>
          ) : (
            <SuccessMessage>
              Contrato confirmado correctamente. ¡Gracias!
            </SuccessMessage>
          )}
        </>
      ) : (
        <p>Cargando contrato...</p>
      )}
    </Container>
  );
};

export default ConfirmacionContrato;
